"use strict";

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.promise");

require("core-js/modules/es6.object.to-string");

var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator");

require("regenerator-runtime/runtime");

var _asyncToGenerator = require("/opt/build/repo/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/opt/build/repo/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/build/repo/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/opt/build/repo/node_modules/@babel/runtime/helpers/inherits");

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var events_1 = require("events");

var StateMachine = require("javascript-state-machine");

var logger_1 = require("./logger");

var Messages = require("./protocol/messages");

var parser_1 = require("./parser");

var twilsockreplyerror_1 = require("./error/twilsockreplyerror");

var backoffretrier_1 = require("./backoffretrier");

var DISCONNECTING_TIMEOUT = 3000; // Wraps asynchronous rescheduling
// Just makes it simpler to find these hacks over the code

function trampoline(f) {
  setTimeout(f, 0);
}
/**
 * Makes sure that body is properly stringified
 */


function preparePayload(payload) {
  switch (typeof payload) {
    case 'undefined':
      return '';

    case 'object':
      return JSON.stringify(payload);

    default:
      return payload;
  }
}

var Request = function Request() {
  _classCallCheck(this, Request);
};

var Response = function Response() {
  _classCallCheck(this, Response);
};

exports.Response = Response;
/**
 * Twilsock channel level protocol implementation
 */

var TwilsockChannel =
/*#__PURE__*/
function (_events_1$EventEmitte) {
  _inherits(TwilsockChannel, _events_1$EventEmitte);

  function TwilsockChannel(websocket, transport, config) {
    var _this;

    _classCallCheck(this, TwilsockChannel);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TwilsockChannel).call(this));
    _this.terminalStates = ['disconnected', 'rejected'];
    _this.lastEmittedState = undefined;
    _this.tokenExpiredSasCode = 20104;
    _this.websocket = websocket;

    _this.websocket.on('connected', function () {
      return _this.fsm.socketConnected();
    });

    _this.websocket.on('disconnected', function (e) {
      return _this.fsm.socketClosed();
    });

    _this.websocket.on('message', function (message) {
      return _this.onIncomingMessage(message);
    });

    _this.websocket.on('socketError', function (e) {
      return _this.emit('connectionError', {
        terminal: false,
        message: e.message,
        httpStatusCode: null,
        errorCode: null
      });
    });

    _this.transport = transport;
    _this.config = config;
    _this.retrier = new backoffretrier_1.BackoffRetrier(config.retryPolicy);

    _this.retrier.on('attempt', function () {
      return _this.retry();
    });

    _this.retrier.on('failed', function (err) {
      logger_1.log.warn("Retrying failed: ".concat(err.message));

      _this.disconnect();
    });

    if (typeof window !== 'undefined' && typeof window.addEventListener !== 'undefined') {
      window.addEventListener('online', function () {
        logger_1.log.debug('Browser reported connectivity state: online');

        _this.fsm.systemOnline();
      });
      window.addEventListener('offline', function () {
        logger_1.log.debug('Browser reported connectivity state: offline');

        _this.websocket.close();

        _this.fsm.socketClosed();
      });
    }

    _this.fsm = new StateMachine({
      init: 'disconnected',
      transitions: [{
        name: 'userConnect',
        from: ['disconnected', 'rejected'],
        to: 'connecting'
      }, {
        name: 'userConnect',
        from: ['connecting', 'connected']
      }, {
        name: 'userDisconnect',
        from: ['connecting', 'initialising', 'connected', 'updating', 'retrying', 'rejected', 'waitSocketClosed', 'waitOffloadSocketClosed'],
        to: 'disconnecting'
      }, {
        name: 'userRetry',
        from: ['retrying'],
        to: 'connecting'
      }, {
        name: 'socketConnected',
        from: ['connecting'],
        to: 'initialising'
      }, {
        name: 'socketClosed',
        from: ['connecting', 'initialising', 'connected', 'updating', 'error', 'waitOffloadSocketClosed'],
        to: 'retrying'
      }, {
        name: 'socketClosed',
        from: ['disconnecting'],
        to: 'disconnected'
      }, {
        name: 'socketClosed',
        from: ['waitSocketClosed'],
        to: 'disconnected'
      }, {
        name: 'socketClosed',
        from: ['rejected'],
        to: 'rejected'
      }, {
        name: 'initSuccess',
        from: ['initialising'],
        to: 'connected'
      }, {
        name: 'initError',
        from: ['initialising'],
        to: 'error'
      }, {
        name: 'tokenRejected',
        from: ['initialising', 'updating'],
        to: 'rejected'
      }, {
        name: 'protocolError',
        from: ['initialising', 'connected', 'updating'],
        to: 'error'
      }, {
        name: 'receiveClose',
        from: ['initialising', 'connected', 'updating'],
        to: 'waitSocketClosed'
      }, {
        name: 'receiveOffload',
        from: ['initialising', 'connected', 'updating'],
        to: 'waitOffloadSocketClosed'
      }, {
        name: 'unsupportedProtocol',
        from: ['initialising', 'connected', 'updating'],
        to: 'unsupported'
      }, {
        name: 'receiveFatalClose',
        from: ['initialising', 'connected', 'updating'],
        to: 'unsupported'
      }, {
        name: 'userUpdateToken',
        from: ['disconnected', 'rejected', 'connecting', 'retrying'],
        to: 'connecting'
      }, {
        name: 'userUpdateToken',
        from: ['connected'],
        to: 'updating'
      }, {
        name: 'updateSuccess',
        from: ['updating'],
        to: 'connected'
      }, {
        name: 'updateError',
        from: ['updating'],
        to: 'error'
      }, {
        name: 'userSend',
        from: ['connected'],
        to: 'connected'
      }, {
        name: 'systemOnline',
        from: ['retrying'],
        to: 'connecting'
      }],
      methods: {
        onConnecting: function onConnecting() {
          _this.setupSocket();

          _this.emit('connecting');
        },
        onEnterInitialising: function onEnterInitialising() {
          _this.sendInit();
        },
        onLeaveInitialising: function onLeaveInitialising() {
          _this.cancelInit();
        },
        onEnterUpdating: function onEnterUpdating() {
          _this.sendUpdate();
        },
        onLeaveUpdating: function onLeaveUpdating() {
          _this.cancelUpdate();
        },
        onEnterRetrying: function onEnterRetrying() {
          _this.initRetry();

          _this.emit('connecting');
        },
        onEnterConnected: function onEnterConnected() {
          _this.resetBackoff();

          _this.onConnected();
        },
        onUserUpdateToken: function onUserUpdateToken() {
          _this.resetBackoff();
        },
        onTokenRejected: function onTokenRejected() {
          _this.resetBackoff();

          _this.closeSocket(true);

          _this.finalizeSocket();
        },
        onUserDisconnect: function onUserDisconnect() {
          _this.closeSocket(true);
        },
        onEnterDisconnecting: function onEnterDisconnecting() {
          _this.startDisconnectTimer();
        },
        onLeaveDisconnecting: function onLeaveDisconnecting() {
          _this.cancelDisconnectTimer();
        },
        onEnterWaitSocketClosed: function onEnterWaitSocketClosed() {
          _this.startDisconnectTimer();
        },
        onLeaveWaitSocketClosed: function onLeaveWaitSocketClosed() {
          _this.cancelDisconnectTimer();
        },
        onEnterWaitOffloadSocketClosed: function onEnterWaitOffloadSocketClosed() {
          _this.startDisconnectTimer();
        },
        onLeaveWaitOffloadSocketClosed: function onLeaveWaitOffloadSocketClosed() {
          _this.cancelDisconnectTimer();
        },
        onDisconnected: function onDisconnected() {
          _this.resetBackoff();

          _this.finalizeSocket();
        },
        onReceiveClose: function onReceiveClose(event, args) {
          _this.onCloseReceived(args);
        },
        onReceiveOffload: function onReceiveOffload(event, args) {
          logger_1.log.debug('onreceiveoffload: ', args);

          _this.modifyBackoff(args.body);

          _this.onCloseReceived(args.status);
        },
        onUnsupported: function onUnsupported() {
          _this.closeSocket(true);

          _this.finalizeSocket();
        },
        onError: function onError(lifecycle, graceful) {
          _this.closeSocket(graceful);

          _this.finalizeSocket();
        },
        onEnterState: function onEnterState(event) {
          if (event.from !== 'none') {
            _this.changeState(event);
          }
        },
        onInvalidTransition: function onInvalidTransition(transition, from, to) {
          logger_1.log.warn('FSM: unexpected transition', from, to);
        }
      }
    });
    return _this;
  }

  _createClass(TwilsockChannel, [{
    key: "changeState",
    value: function changeState(event) {
      logger_1.log.debug("FSM: ".concat(event.transition, ": ").concat(event.from, " --> ").concat(event.to));

      if (this.lastEmittedState !== this.state) {
        this.lastEmittedState = this.state;
        this.emit('stateChanged', this.state);
      }
    }
  }, {
    key: "resetBackoff",
    value: function resetBackoff() {
      logger_1.log.trace('resetBackoff');
      this.retrier.stop();
    }
  }, {
    key: "modifyBackoff",
    value: function modifyBackoff(body) {
      logger_1.log.trace('modifyBackoff', body);
      var backoffPolicy = body ? body.backoff_policy : null;

      if (backoffPolicy && typeof backoffPolicy.reconnect_min_ms === 'number') {
        this.retrier.modifyBackoff(backoffPolicy.reconnect_min_ms);
      }
    }
  }, {
    key: "startDisconnectTimer",
    value: function startDisconnectTimer() {
      var _this2 = this;

      logger_1.log.trace('startDisconnectTimer');

      if (this.disconnectingTimer) {
        clearTimeout(this.disconnectingTimer);
        this.disconnectingTimer = null;
      }

      this.disconnectingTimer = setTimeout(function () {
        logger_1.log.debug('disconnecting is timed out');

        _this2.closeSocket(true);
      }, DISCONNECTING_TIMEOUT);
    }
  }, {
    key: "cancelDisconnectTimer",
    value: function cancelDisconnectTimer() {
      logger_1.log.trace('cancelDisconnectTimer');

      if (this.disconnectingTimer) {
        clearTimeout(this.disconnectingTimer);
        this.disconnectingTimer = null;
      }
    }
  }, {
    key: "initRetry",
    value: function initRetry() {
      logger_1.log.debug('initRetry');

      if (this.retrier.inProgress) {
        this.retrier.attemptFailed();
      } else {
        this.retrier.start();
      }
    }
  }, {
    key: "retry",
    value: function retry() {
      if (this.fsm.state != 'connecting') {
        logger_1.log.trace('retry');
        this.websocket.close();
        this.fsm.userRetry();
      } else {
        logger_1.log.trace('can\t retry as already connecting');
      }
    }
  }, {
    key: "onConnected",
    value: function onConnected() {
      this.emit('connected');
    }
  }, {
    key: "finalizeSocket",
    value: function finalizeSocket() {
      logger_1.log.trace('finalizeSocket');
      this.websocket.close();
      this.emit('disconnected');

      if (this.disconnectedPromiseResolve) {
        this.disconnectedPromiseResolve();
        this.disconnectedPromiseResolve = null;
      }
    }
  }, {
    key: "setupSocket",
    value: function setupSocket() {
      logger_1.log.trace('setupSocket:', this.config.token);
      this.websocket.connect();
    }
  }, {
    key: "onIncomingMessage",
    value: function onIncomingMessage(message) {
      var _parser_1$Parser$pars = parser_1.Parser.parse(message),
          method = _parser_1$Parser$pars.method,
          header = _parser_1$Parser$pars.header,
          payload = _parser_1$Parser$pars.payload;

      if (method !== 'reply') {
        this.confirmReceiving(header);
      }

      if (method === 'notification') {
        this.emit('message', header.message_type, payload);
      } else if (header.method === 'reply') {
        this.transport.processReply({
          id: header.id,
          status: header.status,
          header: header,
          body: payload
        });
      } else if (header.method === 'client_update') {
        if (header.client_update_type === 'token_about_to_expire') {
          this.emit('tokenAboutToExpire');
        }
      } else if (header.method === 'close') {
        if (header.status.code === 308) {
          logger_1.log.debug('Connection has been offloaded');
          this.fsm.receiveOffload({
            status: header.status.status,
            body: payload
          });
        } else if (header.status.code === 406) {
          // Not acceptable message
          var _message = "Server closed connection because can't parse protocol: ".concat(JSON.stringify(header.status));

          this.emitReplyConnectionError(_message, header, true);
          logger_1.log.error(_message);
          this.fsm.receiveFatalClose();
        } else if (header.status.code === 417) {
          // Protocol error
          logger_1.log.error("Server closed connection because can't parse client reply: ".concat(JSON.stringify(header.status)));
          this.fsm.receiveFatalClose(header.status.status);
        } else if (header.status.code === 410) {
          // Expired token
          logger_1.log.warn("Server closed connection: ".concat(JSON.stringify(header.status)));
          this.fsm.receiveClose(header.status.status);
          this.emit('tokenExpired');
        } else if (header.status.code === 401) {
          // Authentication fail
          logger_1.log.error("Server closed connection: ".concat(JSON.stringify(header.status)));
          this.fsm.receiveClose(header.status.status);
        } else {
          logger_1.log.warn('unexpected message: ', header.status); // Try to reconnect

          this.fsm.receiveOffload({
            status: header.status.status,
            body: null
          });
        }
      }
    }
  }, {
    key: "sendInit",
    value: function () {
      var _sendInit = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var reply, isTerminalError;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                logger_1.log.trace('sendInit');
                _context.prev = 1;
                _context.next = 4;
                return this.transport.sendInit();

              case 4:
                reply = _context.sent;
                this.config.updateContinuationToken(reply.continuationToken);
                this.fsm.initSuccess(reply);
                this.emit('initialized', reply);
                this.emit('tokenUpdated');
                _context.next = 15;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](1);

                if (_context.t0 instanceof twilsockreplyerror_1.TwilsockReplyError) {
                  isTerminalError = false;
                  logger_1.log.warn("Init rejected by server: ".concat(JSON.stringify(_context.t0.reply.status)));

                  if (_context.t0.reply.status.code === 401 || _context.t0.reply.status.code === 403) {
                    isTerminalError = true;
                    this.fsm.tokenRejected(_context.t0.reply.status);

                    if (_context.t0.reply.status.errorCode === this.tokenExpiredSasCode) {
                      this.emit('tokenExpired');
                    }
                  } else if (_context.t0.reply.status.code === 429) {
                    this.modifyBackoff(_context.t0.reply.body);
                    this.fsm.initError(true);
                  } else if (_context.t0.reply.status.code === 500) {
                    this.fsm.initError(false);
                  } else {
                    this.fsm.initError(true);
                  }

                  this.emitReplyConnectionError(_context.t0.message, _context.t0.reply, isTerminalError);
                } else {
                  this.emit('connectionError', {
                    terminal: true,
                    message: _context.t0.message,
                    httpStatusCode: null,
                    errorCode: null
                  });
                  this.fsm.initError(true);
                }

                this.emit('tokenUpdated', _context.t0);

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[1, 11]]);
      }));

      function sendInit() {
        return _sendInit.apply(this, arguments);
      }

      return sendInit;
    }()
  }, {
    key: "sendUpdate",
    value: function () {
      var _sendUpdate = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var message, reply, isTerminalError;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                logger_1.log.trace('sendUpdate');
                message = new Messages.Update(this.config.token);
                _context2.prev = 2;
                _context2.next = 5;
                return this.transport.sendWithReply(message);

              case 5:
                reply = _context2.sent;
                this.fsm.updateSuccess(reply.body);
                this.emit('tokenUpdated');
                _context2.next = 14;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2["catch"](2);

                if (_context2.t0 instanceof twilsockreplyerror_1.TwilsockReplyError) {
                  isTerminalError = false;
                  logger_1.log.warn("Token update rejected by server: ".concat(JSON.stringify(_context2.t0.reply.status)));

                  if (_context2.t0.reply.status.code === 401 || _context2.t0.reply.status.code === 403) {
                    isTerminalError = true;
                    this.fsm.tokenRejected(_context2.t0.reply.status);

                    if (_context2.t0.reply.status.errorCode === this.tokenExpiredSasCode) {
                      this.emit('tokenExpired');
                    }
                  } else if (_context2.t0.reply.status.code === 429) {
                    this.modifyBackoff(_context2.t0.reply.body);
                    this.fsm.updateError(_context2.t0.reply.status);
                  } else {
                    this.fsm.updateError(_context2.t0.reply.status);
                  }

                  this.emitReplyConnectionError(_context2.t0.message, _context2.t0.reply, isTerminalError);
                } else {
                  this.emit('error', false, _context2.t0.message, null, null);
                  this.fsm.updateError(_context2.t0);
                }

                this.emit('tokenUpdated', _context2.t0);

              case 14:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[2, 10]]);
      }));

      function sendUpdate() {
        return _sendUpdate.apply(this, arguments);
      }

      return sendUpdate;
    }()
  }, {
    key: "emitReplyConnectionError",
    value: function emitReplyConnectionError(message, header, terminal) {
      var description = header.status && header.status.description ? header.status.description : message;
      var httpStatusCode = header.status.code;
      var errorCode = header.status && header.status.errorCode ? header.status.errorCode : null;
      this.emit('connectionError', {
        terminal: terminal,
        message: description,
        httpStatusCode: httpStatusCode,
        errorCode: errorCode
      });
    }
  }, {
    key: "cancelInit",
    value: function cancelInit() {
      logger_1.log.trace('cancelInit'); // TODO: implement
    }
  }, {
    key: "cancelUpdate",
    value: function cancelUpdate() {
      logger_1.log.trace('cancelUpdate'); // TODO: implement
    }
    /**
     * Should be called for each message to confirm it received
     */

  }, {
    key: "confirmReceiving",
    value: function confirmReceiving(messageHeader) {
      logger_1.log.trace('confirmReceiving');

      try {
        this.transport.send(new Messages.Reply(messageHeader.id));
      } catch (e) {
        logger_1.log.debug('failed to confirm packet receiving', e);
      }
    }
    /**
     * Shutdown connection
     */

  }, {
    key: "closeSocket",
    value: function closeSocket(graceful) {
      var _this3 = this;

      logger_1.log.trace("closeSocket (graceful: ".concat(graceful, ")"));

      if (graceful && this.transport.isConnected) {
        this.transport.sendClose();
      }

      this.websocket.close();
      trampoline(function () {
        return _this3.fsm.socketClosed();
      });
    }
    /**
     * Initiate the twilsock connection
     * If already connected, it does nothing
     */

  }, {
    key: "connect",
    value: function connect() {
      logger_1.log.trace('connect');
      this.fsm.userConnect();
    }
    /**
     * Close twilsock connection
     * If already disconnected, it does nothing
     */

  }, {
    key: "disconnect",
    value: function disconnect() {
      var _this4 = this;

      logger_1.log.trace('disconnect');

      if (this.fsm.is('disconnected')) {
        return Promise.resolve();
      }

      return new Promise(function (resolve) {
        _this4.disconnectedPromiseResolve = resolve;

        _this4.fsm.userDisconnect();
      });
    }
    /**
     * Update fpa token for twilsock connection
     */

  }, {
    key: "updateToken",
    value: function updateToken(token) {
      var _this5 = this;

      logger_1.log.trace('updateToken:', token);
      return new Promise(function (resolve, reject) {
        _this5.once('tokenUpdated', function (e) {
          if (e) {
            reject(e);
          } else {
            resolve();
          }
        });

        _this5.fsm.userUpdateToken();
      });
    }
  }, {
    key: "onCloseReceived",
    value: function onCloseReceived(reason) {
      this.websocket.close();
    }
  }, {
    key: "isConnected",
    get: function get() {
      return this.state === 'connected' && this.websocket.isConnected;
    }
  }, {
    key: "state",
    get: function get() {
      switch (this.fsm.state) {
        case 'connecting':
        case 'initialising':
        case 'retrying':
        case 'error':
          return 'connecting';

        case 'updating':
        case 'connected':
          return 'connected';

        case 'rejected':
          return 'rejected';

        case 'disconnecting':
        case 'waitSocketClosed':
        case 'waitOffloadSocketClosed':
          return 'disconnecting';

        case 'disconnected':
        default:
          return 'disconnected';
      }
    }
  }, {
    key: "isTerminalState",
    get: function get() {
      return this.terminalStates.indexOf(this.fsm.state) !== -1;
    }
  }]);

  return TwilsockChannel;
}(events_1.EventEmitter);

exports.TwilsockChannel = TwilsockChannel;
exports.TwilsockImpl = TwilsockChannel;